import { ArrowUpRight, Newspaper } from "@phosphor-icons/react";
import { PageHero, CTASection } from "../components/Sections";
import { Reveal } from "../components/Reveal";
import { usePress } from "../hooks/usePublicContent";

export default function News() {
  const { press, isLoading } = usePress();

  return (
    <div data-testid="news-page">
      <PageHero
        overline="News & Approfondimenti"
        title="Riviste e magazine sull'evoluzione della professione."
        subtitle="Una selezione di articoli e approfondimenti dal mondo del bar: tendenze, tecniche e cultura del settore. E quando la stampa parlerà di me, lo troverai qui."
        image="/media/bartematico.jpg"
      />

      <section className="pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {isLoading ? (
            <p className="text-[#A1A1AA]">Caricamento...</p>
          ) : press.length === 0 ? (
            <Reveal>
              <div className="bg-[#111113] border border-white/5 rounded-sm p-12 text-center">
                <div className="w-16 h-16 rounded-full bg-[#D97736]/10 flex items-center justify-center text-[#D97736] mx-auto">
                  <Newspaper size={30} />
                </div>
                <h3 className="mt-6 font-display text-2xl font-semibold">Presto disponibile</h3>
                <p className="mt-3 text-[#A1A1AA] max-w-md mx-auto">Qui raccoglierò articoli e approfondimenti da riviste e magazine del settore sull'evoluzione della professione.</p>
              </div>
            </Reveal>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {press.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.08}>
                  <a
                    href={p.url || "#"}
                    target={p.url ? "_blank" : undefined}
                    rel="noreferrer"
                    data-testid={`press-card-${p.id}`}
                    className="group block h-full bg-[#111113] border border-white/5 rounded-sm overflow-hidden hover:border-[#D97736]/40 transition-all"
                  >
                    {p.image && (
                      <div className="h-48 overflow-hidden">
                        <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                      </div>
                    )}
                    <div className="p-6">
                      <div className="flex items-center gap-2 text-xs text-[#D97736] font-semibold uppercase tracking-wider">
                        <span>{p.source || "Stampa"}</span>
                        {p.date && <span className="text-[#71717A] normal-case tracking-normal">· {p.date}</span>}
                      </div>
                      <h3 className="mt-3 font-display text-xl font-semibold leading-snug">{p.title}</h3>
                      {p.excerpt && <p className="mt-3 text-[#A1A1AA] text-sm leading-relaxed">{p.excerpt}</p>}
                      {p.url && (
                        <span className="mt-4 inline-flex items-center gap-1.5 text-[#D97736] text-sm font-semibold">
                          Leggi l'articolo <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                        </span>
                      )}
                    </div>
                  </a>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
